import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { Menu, X, Zap } from 'lucide-react';
export const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'How It Works',
    path: '/#how-it-works'
  }, {
    name: 'Characters',
    path: '/characters'
  }, {
    name: 'Pricing',
    path: '/pricing'
  }, {
    name: 'Creators',
    path: '/creator'
  }];
  return <header className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-charcoal/95 backdrop-blur-md border-b border-white/10 py-3' : 'bg-transparent py-5'}`} data-id="element-349">
      <div className="container mx-auto px-4 md:px-6 flex items-center justify-between" data-id="element-350">
        <Link to="/" className="flex items-center gap-2 z-50" data-id="element-351">
          <Zap className="text-lime fill-lime" size={28} data-id="element-352" />
          <span className="font-heading font-black text-3xl tracking-tighter italic -skew-x-6" data-id="element-353">
            ITS ON <span className="text-lime" data-id="element-354">FANTASY</span>
          </span>
        </Link>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8" data-id="element-355">
          {navLinks.map(link => <Link key={link.name} to={link.path} className="text-sm font-bold uppercase tracking-wider text-slate hover:text-white transition-colors" data-id="element-356">
              {link.name}
            </Link>)}
          <Link to="/pricing" className="bg-lime text-charcoal px-6 py-3 rounded-lg font-black font-heading text-xl uppercase tracking-wide hover:bg-white hover:scale-105 transition-all shadow-[0_4px_15px_rgba(200,255,0,0.3)]" data-id="element-357">
            Start Your Season
          </Link>
        </nav>

        {/* Mobile Toggle */}
        <button className="md:hidden z-50 text-white" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} data-id="element-358">
          {isMobileMenuOpen ? <X size={28} data-id="element-359" /> : <Menu size={28} data-id="element-360" />}
        </button>

        {/* Mobile Menu */}
        <AnimatePresence data-id="element-361">
          {isMobileMenuOpen && <motion.div initial={{
          opacity: 0,
          y: -20
        }} animate={{
          opacity: 1,
          y: 0
        }} exit={{
          opacity: 0,
          y: -20
        }} className="absolute top-0 left-0 w-full h-screen bg-charcoal flex flex-col items-center justify-center gap-8 z-40" data-id="element-362">
              {navLinks.map(link => <Link key={link.name} to={link.path} onClick={() => setIsMobileMenuOpen(false)} className="text-3xl font-black font-heading uppercase tracking-wider text-white" data-id="element-363">
                  {link.name}
                </Link>)}
              <Link to="/pricing" onClick={() => setIsMobileMenuOpen(false)} className="bg-lime text-charcoal px-8 py-4 rounded-lg font-black font-heading text-2xl uppercase tracking-wide mt-4" data-id="element-364">
                Start Your Season
              </Link>
            </motion.div>}
        </AnimatePresence>
      </div>
    </header>;
};
export const Footer = () => {
  return <footer className="bg-dark border-t border-white/10 pt-20 pb-8" data-id="element-365">
      <div className="container mx-auto px-4 md:px-6" data-id="element-366">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-16" data-id="element-367">
          <div className="col-span-1 md:col-span-1" data-id="element-368">
            <Link to="/" className="flex items-center gap-2 mb-4" data-id="element-369">
              <Zap className="text-lime fill-lime" size={24} data-id="element-370" />
              <span className="font-heading font-black text-2xl tracking-tighter italic -skew-x-6" data-id="element-371">
                ITS ON <span className="text-lime" data-id="element-372">FANTASY</span>
              </span>
            </Link>
            <p className="text-slate text-lg font-medium" data-id="element-373">
              The AI that ruins your Sunday... in the best way. Because your
              league chat was getting boring.
            </p>
          </div>

          <div data-id="element-374">
            <h4 className="font-heading font-black text-xl uppercase tracking-wider mb-6" data-id="element-375">
              Product
            </h4>
            <ul className="space-y-3" data-id="element-376">
              <li data-id="element-377">
                <Link to="/#how-it-works" className="text-slate hover:text-lime transition-colors" data-id="element-378">
                  How It Works
                </Link>
              </li>
              <li data-id="element-379">
                <Link to="/characters" className="text-slate hover:text-lime transition-colors" data-id="element-380">
                  Characters
                </Link>
              </li>
              <li data-id="element-381">
                <Link to="/pricing" className="text-slate hover:text-lime transition-colors" data-id="element-382">
                  Pricing
                </Link>
              </li>
              <li data-id="element-383">
                <Link to="/creator" className="text-slate hover:text-lime transition-colors" data-id="element-384">
                  Creator Program
                </Link>
              </li>
            </ul>
          </div>

          <div data-id="element-385">
            <h4 className="font-heading font-black text-xl uppercase tracking-wider mb-6" data-id="element-386">
              For Leagues
            </h4>
            <ul className="space-y-3" data-id="element-387">
              <li data-id="element-388">
                <Link to="/pricing" className="text-slate hover:text-lime transition-colors" data-id="element-389">
                  Commissioner Pack
                </Link>
              </li>
              <li data-id="element-390">
                <Link to="/fundraiser" className="text-slate hover:text-lime transition-colors" data-id="element-391">
                  School Fundraising
                </Link>
              </li>
              <li data-id="element-392">
                <Link to="/pricing" className="text-slate hover:text-lime transition-colors" data-id="element-393">
                  Affiliate Program
                </Link>
              </li>
            </ul>
          </div>

          <div data-id="element-394">
            <h4 className="font-heading font-black text-xl uppercase tracking-wider mb-6" data-id="element-395">
              Company
            </h4>
            <ul className="space-y-3" data-id="element-396">
              <li data-id="element-397">
                <a href="#" className="text-slate hover:text-lime transition-colors" data-id="element-398">
                  About
                </a>
              </li>
              <li data-id="element-399">
                <a href="#" className="text-slate hover:text-lime transition-colors" data-id="element-400">
                  Contact
                </a>
              </li>
              <li data-id="element-401">
                <a href="#" className="text-slate hover:text-lime transition-colors" data-id="element-402">
                  Terms
                </a>
              </li>
              <li data-id="element-403">
                <a href="#" className="text-slate hover:text-lime transition-colors" data-id="element-404">
                  Privacy
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-405">
          <p className="text-slate text-sm" data-id="element-406">© 2026 ITSONfantasy.com</p>
          <p className="text-slate text-sm text-center md:text-right" data-id="element-407">
            Not affiliated with Sleeper, ESPN, or your real feelings about your
            terrible fantasy team.
          </p>
        </div>
      </div>
    </footer>;
};